import React from "react";
import { Box, Container } from "@mui/material";
import { Header } from "../0_layout/HeaderFooter";
import { Footer } from "../0_layout/Footer";
//import { useNavigate } from "react-router-dom";

const Books = ({ data, teacher = false }) => {
 //const [enquire, changeEnquire] = useState(false);
  //console.log('component data: '+JSON.stringify(data));
  //const navigate = useNavigate();
  
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Header />
      </Box>
      
      <Container maxWidth="lg">
        <Box sx={{mt: 18}} dangerouslySetInnerHTML={{ __html: data.longDescription }}></Box>
      </Container>
      
      <Box sx={{ width: '100%' }}>
        <Footer />
      </Box>
    </>
  );
};

export default Books;

